export default {
    'appConfig.label.preset-color': 'Màu sắc',
    'appConfig.label.surface-color': 'Màu nền',
    'appConfig.label.theme': 'Chủ đề',
    'appConfig.label.menu-mode': 'Kiểu menu'
};
